module.exports = __webpack_public_path__ + "img/icon-gen-viewairtimelog.6a1d8c5d.png";